module.exports = __webpack_public_path__ + "img/dwgk_banner.8aea148c.png";